import CeisaHsCodeIndex from "@/components/exim/ceisa/hs_code/CeisaHsCodeIndex.vue";
import CeisaHsCodeDetail from "@/components/exim/ceisa/hs_code/CeisaHsCodeDetail.vue";
import CeisaHsCodeCreate from "@/components/exim/ceisa/hs_code/CeisaHsCodeCreate.vue";
import CeisaHsCodeEdit from "@/components/exim/ceisa/hs_code/CeisaHsCodeEdit.vue";

let CeisaHsCodeRoute= [
    {
        path: '',
        meta: {
          title: "Ceisa System Code",
        },
        name: "CeisaHsCodeIndex",
        component: CeisaHsCodeIndex
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Ceisa System Code Detail",
        },
        name: "CeisaHsCodeDetail",
        component: CeisaHsCodeDetail
    },
     
    {
      path: 'create',
      meta: {
        title: "Ceisa System Code Create",
      },
      name: "CeisaHsCodeCreate",
      component: CeisaHsCodeCreate
    },


    {
      path: 'edit/:id',
      meta: {
        title: "Ceisa System Code Update",
      },
      name: "CeisaHsCodeEdit",
      component: CeisaHsCodeEdit
    },
     
    
]

export default CeisaHsCodeRoute
  